import logo from './logo.svg';
import './App.css';
import { Application } from 'react-rainbow-components';
import { Demo } from './page/Demo';
import { Dark } from './Colors';

function App() {

  return (
    <Application style={{color: Dark.accent, backgroundColor: Dark.background}} theme={{rainbow: {palette: {brand: Dark.accent, mainBackground: Dark.background}}}}>
      <Demo />
    </Application>
  );

  // return (
  //   <div className="App">
  //     <header className="App-header">
  //       <img src={logo} className="App-logo" alt="logo" />
  //       <p>
  //         Edit <code>src/App.js</code> and save to reload.
  //       </p>
  //       <a
  //         className="App-link"
  //         href="https://reactjs.org"
  //         target="_blank"
  //         rel="noopener noreferrer"
  //       >
  //         Learn React
  //       </a>
  //     </header>
  //   </div>
  // );
}

export default App;
